import { createSlice } from '@reduxjs/toolkit';
import { ActividadTipoEnum } from 'enums/rutaSesionTipo';

const initialState = ActividadTipoEnum.grupal;

const currentTipoActividadStateSlice = createSlice({
	name: 'currentTipoActividadState',
	initialState,
	reducers: {
		setCurrentTipoActividadState: (state, action) => {
			return action.payload;
		}
	}
});

export const { setCurrentTipoActividadState } = currentTipoActividadStateSlice.actions;

export default currentTipoActividadStateSlice.reducer;
